import iconsPng from '@/assets/img/png/icons';
import { formatDomainLabel } from '@/constants/contentDomains';
import { TContentDomain } from '@/types/Content.types';
import { THealthDomain } from '@/types/Health.types';
import { Box, HStack, Image } from '@chakra-ui/react';

// The same pale-purple tile and purple artwork are used wherever content shows domains.
const DomainIconTiles = ({
  domains,
  max = 7,
}: {
  domains: TContentDomain[];
  max?: number;
}) => {
  return (
    <HStack gap="6px">
      {domains.slice(0, max).map((domain) => (
        <Box key={domain} backgroundColor="background.lightPurple" padding="5px" borderRadius="8px">
          <Image
            src={iconsPng.wellnessDomainsPurple[domain as THealthDomain]}
            width="16px"
            height="16px"
            alt={formatDomainLabel(domain)}
          />
        </Box>
      ))}
    </HStack>
  );
};

export default DomainIconTiles;
